// src/pages/Rules.js
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Rules = () => {
  const { t, setLanguageFromURL } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang) {
      setLanguageFromURL(lang);
    }
  }, [lang, setLanguageFromURL]);

  return (
    <div 
      className="rules-page"
      role="main"
      aria-labelledby="rules-title"
    >
      <div className="container">
        <header className="page-header">
          <h1 id="rules-title">Klassikalise loterii Vikinglotto mängureeglid Eesti Vabariigis alates 22.05.2026</h1>

        </header>
  
        <div 
          className="rules-content"
          role="article"
          aria-labelledby="rules-title"
        >
   
          
          <section className="rules" aria-labelledby="section1-heading">
       
						<h2>1.	VIKINGLOTTO KORRALDAMINE</h2>
<ul>
<li><span>1.1.</span>Vikinglotto on klassikaline loterii, mida korraldavad ühiselt erinevate riikide litsentseeritud loteriikorraldajad (edaspidi: partner).</li>
<li><span>1.2.</span>Eesti Vabariigi territooriumil korraldab Vikinglottot Eesti Loto AS (edaspidi: Eesti Loto), asukoht Hallivanamehe 4, 11317 Tallinn, registrikood 10281170.</li>
<li><span>1.3.</span>Eesti Loto korraldab Vikinglottot vastavalt käesolevatele mängureeglitele.</li>
<li><span>1.4.</span>Käesolevad mängureeglid kehtivad koos Eesti Loto klassikaliste loteriide üldreeglitega.</li>
</ul>

<h2>2.	MÕISTED</h2>
<ul>
<li><span>2.1.</span>Mängukombinatsioon on Vikinglotto loosimisel osalev numbrite kogum, mis on valitud mängija või Eesti Loto infosüsteemi poolt (pliks-plaks) ja mis koosneb kuuest põhinumbrist vahemikus 1 kuni 48 ning ühest lisanumbrist vahemikus 1 kuni 5. </li>
<li><span>2.2.</span>Süsteemimäng on Vikinglotto loosimisel osalev mängukombinatsioonide kogum. Selle moodustamiseks tuleb mängijal valida põhi- ja lisanumbrite arv ning soovitud numbrid (kas ise valides või pliks-plaks). Loosimisel osalevad kõik need kuuest põhinumbrist ja ühest lisanumbrist moodustatavad erinevad mängukombinatsioonid, mida valitud numbritega on võimalik moodustada. Loosimisel osalevate mängukombinatsioonide arv, mis vastab valitud põhi- ja lisanumbrite arvule, on näidatud järgmises tabelis: 

								<table className="alt-table">
									<thead>
										<tr>
											<th></th>
											<th></th>
											<th colspan="5">Lisanumbreid</th>
										</tr>
                    </thead>
									<tbody>
										<tr>
											<td></td>
											<td></td>
											<td>1</td>
											<td>2</td>
											<td>3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>6</td>
											<td className="highlight">1*</td>
											<td className="highlight">2</td>
											<td className="highlight">3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>7</td>
											<td className="highlight">7</td>
											<td className="highlight">14</td>
											<td className="highlight">21</td>
											<td>28</td>
											<td>35</td>
										</tr>
										<tr>
											<td></td>
											<td>8</td>
											<td className="highlight">28</td>
											<td className="highlight">56</td>
											<td className="highlight">84</td>
											<td>112</td>
											<td>140</td>
										</tr>
										<tr>
											<td></td>
											<td>9</td>
											<td className="highlight">84</td>
											<td className="highlight">168</td>
											<td className="highlight">252</td>
											<td>336</td>
											<td>420</td>
										</tr>
										<tr>
											<td></td>
											<td>10</td>
											<td className="highlight">210</td>
											<td className="highlight">420</td>
											<td className="highlight">630</td>
											<td>840</td>
										</tr>
										<tr>
											<td></td>
											<td>11</td>
											<td>462</td>
											<td>924</td>
										</tr>
										<tr>
											<td></td>
											<td>12</td>
											<td>924</td>
										</tr>
									</tbody>
								</table>
</li></ul>
								<span className="alt-content">* Kuuest põhinumbrist ja ühest lisanumbrist moodustatud mängukombinatsiooni ei loeta süsteemimänguks.</span>
								<h2>3.	LOOSIMISEL OSALEMINE</h2>
								<ul>
<li><span>3.1.</span>Loosimisel osalemiseks teeb mängija pileti ostmisega panuse mängukombinatsioonile.  Süsteemimängu korral teeb mängija panuse valitud hulga põhi- ja lisanumbritest moodustatud mängukombinatsioonidele. </li>
<li><span>3.2.</span>Vikinglotto piletil võib olla üks kuni kümme mängukombinatsiooni või üks süsteemimäng. </li>
<li><span>3.3.</span>Vikinglotto pileti saab osta korraga kuni kümneks loosimiseks. Eesti Loto jätab endale õiguse piirata piletite etteostmise võimalust. </li>
<li><span>3.4.</span>Ühe mängukombinatsiooni hind (panus) ühe loosimise kohta on 1,50 eurot. Pileti hind arvutatakse, korrutades panuse (1,50 €) mängukombinatsioonide ja loosimiste arvuga. </li>
<li><span>3.5.</span>Pileti saab osta:
<ul>
<li><span>3.5.1.</span>Eesti Loto edasimüüjate müügipunktidest; </li>
<li><span>3.5.2.</span>interneti vahendusel Eesti Loto veebikeskkonnas: www.eestiloto.ee;</li>
<li><span>3.5.3.</span>telefonikõnega ehk M-loto teenust kasutades (helistades numbrile 17788*2). </li></ul></li>
<li><span>3.6.</span>Piletite müük konkreetsele loosimisele lõpetatakse loosimise päeval kell 19.00 (Eesti aja järgi). </li>
</ul>
<h2>4.	VIKINGLOTTO VÕIDUNUMBRITE LOOSIMINE</h2>
<ul>
<li><span>4.1.</span>Vikinglotto loosimised viib läbi Norsk Tipping AS, asukohaga Hamar, Norra. Loosimised toimuvad igal kolmapäeval Kesk-Euroopa aja ehk CET järgi kell 19.00 (Eesti aja järgi kell 20.00). Partnerite ühisel otsusel võib loosimise aega erakorralistel juhtudel muuta.   </li>
<li><span>4.2.</span>Loosimisel kasutatakse kahte lototroni. Esimeses lototronis kasutatakse pallikomplekti numbritega 1 kuni 48, teises lototronis kasutatakse pallikomplekti numbritega 1 kuni 5.</li>
<li><span>4.3.</span>Loosimise käigus loositakse:</li>
<li><span>4.3.1.</span>esmalt esimese lototroniga kuus põhinumbrit vahemikus 1 kuni 48; </li>
<li><span>4.3.2.</span>seejärel teise lototroniga üks lisanumber vahemikus 1 kuni 5.</li>
</ul>
<h2>5.	VIKINGLOTTO LISAVÕIDUD </h2>
<ul><li><span>5.1.</span>Vikinglotto lisavõitudena loositakse aasta jooksul välja 1 200 000 eurot. Eesti Loto teavitab lisavõitude loosimiste toimumisest ja tingimustest mängijaid vähemalt üks kuu enne loosimist oma veebilehe ja meedia vahendusel. Lisavõitude loosimises osalevad kõik vastaval perioodil ostetud Vikinglotto piletid (ilma täiendava registreerimise vajaduseta). </li>
<li><span>5.2.</span>Lisavõitude loosimiseks kasutatakse juhuarvu generaatorit. </li>
<li><span>5.3.</span>Vikinglotto lisavõidud makstakse välja Eesti Loto reservfondist.</li>
<li><span>5.4.</span>Vikinglotto lisavõitude loosimised viiakse läbi Eesti Loto kontoris, aadressil Hallivanamehe 4, Tallinn või telestuudios.</li></ul>

<h2>6.	VÕIDUD, VÕIDUFOND JA SELLE JAOTUS </h2>
<ul><li><span>6.1.</span>Vikinglotto võidud jagunevad võidutasanditesse olenevalt väljaloositud võidunumbritega kokku langevate mängukombinatsiooni numbrite arvust (tabamus). Võidutasandid on nummerdatud ühest üheksani (vt punkt 6.2) nii, et esimesel (I) võidutasandil on kõige suurema tabamuste arvuga ja üheksandal (IX) võidutasandil kõige väiksema tabamuste arvuga võidud. </li>
<li><span>6.2.</span>Vikinglotto võidutasandid on järgmised:

									<table className="table-half">
										<tr>
											<th>Võidutasand</th>
											<th>Tabamus</th>
										</tr>
										<tr>
											<td>I</td>
											<td>6 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>II</td>
											<td>6 põhinumbrit</td>
										</tr>
										<tr>
											<td>III</td>
											<td>5 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>IV</td>
											<td>5 põhinumbrit</td>
										</tr>
										<tr>
											<td>V</td>
											<td>4 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>VI</td>
											<td>4 põhinumbrit</td>
										</tr>
										<tr>
											<td>VII</td>
											<td>3 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>VIII</td>
											<td>3 põhinumbrit</td>
										</tr>
										<tr>
											<td>IX</td>
											<td>2 põhinumbrit + 1 lisanumber</td>
										</tr>
									</table>
								</li>
<li><span>6.3.</span>Vikinglotto võidufondi arvatakse igal loosimisel 48% kõikide mängijate poolt konkreetseks loosimiseks tehtud panustest. </li>
<li><span>6.4.</span>Võidufond jaguneb järgmiselt:
<ul>
<li><span>6.4.1.</span>Vikinglotto I võidutasandi (jackpot’i) võidufond, kuhu kantakse igast panusest 0,13 eurot;</li>
<li><span>6.4.2.</span>Vikinglotto II võidutasandi võidufond, kuhu kantakse igast panusest 0,013 eurot;.</li>
<li><span>6.4.3.</span>Vikinglotto ühine reservfond, kuhu kantakse igast panusest 0,042 eurot;</li>
<li><span>6.4.4.</span>Eesti Loto omavõidufond, mille moodustab ülejäänud osa võidufondist ja mis jaguneb III kuni IX võidutasandi ja Eesti Loto reservfondi vahel järgmiselt:

											<table className="table-half remove-margin">
											<tbody>	<tr>
													<th>Võidu tasand</th>
													<th>Osakaal omavõidufondist</th>
												</tr>
												<tr>
													<td>III</td>
													<td>16,5 %</td>
												</tr>
												<tr>
													<td>IV</td>
													<td>7,5 %</td>
												</tr>
												<tr>
													<td>V</td>
													<td>8,5 %</td>
												</tr>
												<tr>
													<td>VI</td>
													<td>6,5 %</td>
												</tr>
												<tr>
													<td>VII</td>
													<td>9,0 %</td>
												</tr>
												<tr>
													<td>VIII</td>
													<td>13,5 %</td>
												</tr>
                        <tr>
												<td>IX</td>
												<td>8,0 %</td>
												</tr>
												<tr>
													<td>Eesti Loto reservfond</td>
													<td>30,5 %</td>
												</tr>	</tbody>
											</table>
											</li></ul></li>
<li><span>6.5.</span>Vikinglotto I ja II võidutasandi võidufondid ja Vikinglotto reservfond on partneritega ühised, ülejäänud võidufondid moodustuvad vaid Eestis müüdud mängukombinatsioonide põhiselt.</li>
<li><span>6.6.</span>I võidutasandi võidufond koosneb:</li>
<li><span>6.6.1.</span>kõigi partnerite poolt selleks konkreetseks loosimiseks müüdud mängukombinatsioonide koguarvust korrutatuna 0,13 euroga;</li>
<li><span>6.6.2.</span>eelmistest loosimistest vastavalt mängureeglite punktile 6.12 edasi kandunud I võidutasandi võidufondist;</li>
<li><span>6.6.3.</span>Vikinglotto ühise reservfondi limiiti ületavast summast vastavalt punktile 6.10;</li>
<li><span>6.6.4.</span>II võidutasandi võidufondi limiiti ületavast summast punktis 6.9 nimetatud juhul.</li>
<li><span>6.7.</span>I võidutasandi võidufondile on kehtestatud minimaalne suurus 3 miljonit eurot ja maksimaalne suurus 25 miljonit eurot. Võidufondi minimaalne suurus garanteeritakse Vikinglotto ühisest reservfondist. Juhul kui I võidutasandi võidufond ületab võidufondi maksimaalse suuruse, lisatakse üle jääv summa sama loosimise II võidutasandi võidufondile. </li>
<li><span>6.8.</span>II võidutasandi võidufond koosneb: <ul>
<li><span>6.8.1.</span>kõigi partnerite poolt selleks konkreetseks loosimiseks müüdud mängukombinatsioonide koguarvust korrutatuna 0,013 euroga;</li>
<li><span>6.8.2.</span>eelmistest loosimistest vastavalt mängureeglite punktile 6.12. edasi kandunud II võidutasandi võidufondist;</li>
<li><span>6.8.3.</span>I võidutasandi võidufondi limiiti ületavast summast vastavalt punktile 6.7.</li></ul></li>
<li><span>6.9.</span>II võidutasandi võidufondile on kehtestatud maksimaalne suurus 25 miljonit eurot. Juhul kui II võidutasandi võidufond ületab võidufondi maksimaalse suuruse, lisatakse üle jääv summa järgmise loosimise I võidutasandi võidufondile.</li>
<li><span>6.10.</span>Vikinglotto ühisele reservfondile on kehtestatud maksimaalne suurus 20 miljonit eurot. Juhul kui Vikinglotto ühise reservfondi suurus ületab maksimaalse suuruse, lisatakse üle jääv summa järgmise loosimise I võidutasandi võidufondile.</li>
<li><span>6.11.</span>Võidutasandi võitja(te)ks on mängija(d), kes on saanud võidutasandile vastava tabamuse. Võidutasandi võidu suurus saadakse vastava võidutasandi võidufondi jagamisel vastava võidutasandi võitjate arvuga.</li>
<li><span>6.12.</span>Võidu puudumise korral konkreetsel võidutasandil lisatakse selle võidutasandi võidufond järgmise loosimise sama võidutasandi võidufondile. Protseduuri jätkatakse loosimisest loosimiseni kuni vastava võidutasandi võidu/võitude väljaloosimiseni. </li>
<li><span>6.13.</span>Ühe mängukombinatsiooniga on võimalik saada ühel loosimisel vaid üks võit. Kui mängija mängukombinatsioon vastab erinevate võidutasandite tabamustele, siis loetakse võiduks ainult kõige kõrgemale võidutasandile vastav, ehk kõige suurema tabamuste arvuga võit. </li>
<li><span>6.14.</span>Eesti Loto poolt müüdud Vikinglotto mängukombinatsiooniga saadud võidu minimaalne suurus on 1,50 eurot. Juhul kui võidu arvestuslik suurus on alla 1,50 euro, katab Eesti Loto puuduoleva summa Eesti Loto reservfondist.</li>
<li><span>6.15.</span>Kõik I ja II võidutasandi võidud ümardatakse kümne sendi täpsusega allapoole ning võit makstakse välja vastavalt ümardatud suurusele. Ümardustest tekkiv vahe arvatakse Vikinglotto ühisesse reservfondi.</li>
<li><span>6.16.</span>Kõik III- IX võidutasandi võidud ümardatakse kümne sendi täpsusega allapoole ja võit makstakse välja vastavalt ümardatud suurusele. Ümardustest tekkiv vahe arvatakse Eesti Loto reservfondi.</li>
<li><span>6.17.</span>Kõik I ja II võidutasandi vormistamata võidud suuruses 3 miljonit eurot või üle selle kantakse Vikinglotto ühisesse reservfondi. Väiksemad vormistamata võidud arvatakse Eesti Loto reservfondi.</li>
<li><span>6.18.</span>Eesti Loto edasimüüjad maksavad võidunõuded välja ainult Eesti Loto edasimüüjate poolt väljastatud ja müüdud piletite alusel. Eesti Loto ei maksa võidunõuet välja pileti alusel, mis on ostetud mõne teise partneri vahendusel.</li>
</ul>
					
          </section>
        </div>
      </div>
    </div>
  );
};

export default Rules;